/**
 * Experience API 패키지 URL
 * @type {string}
 */
const packages = {
    auth: `/auth`,
};

/**
 * Experience API 업무 구분 URL
 * @type {string}
 */
const sectors = {
    auth: {
        user: `${packages.auth}/user`,
    },
};

/**
 * Experience API 업무 세구분 URL
 * @type {string}
 */
const details = {
    auth: {
        user: {
            login: `${sectors.auth.user}/login`,
        },
    },
};

/**
 * Experience API 엔드포인트 URL
 * @type {string}
 */
export const APIS = {
    auth: {
        user: {
            login: {
                logout: `${details.auth.user.login}/logout`,
                extend: `${details.auth.user.login}/extend`,
                inquirySessionInfo: `${details.auth.user.login}/inquirySessionInfo`,
            },
        },
    },
};
